export enum CareTerminationReason {
  CANCELLATION = 'CANCELLATION',

  DEATH = 'DEATH',
}
